var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.25C19.3995 2.25 21.75 4.60051 21.75 7.5V16.5C21.75 19.3995 19.3995 21.75 16.5 21.75H7.5C4.60051 21.75 2.25 19.3995 2.25 16.5V7.5C2.25 4.60051 4.60051 2.25 7.5 2.25H16.5ZM7.5 3.75C5.42893 3.75 3.75 5.42893 3.75 7.5V16.5C3.75 18.5711 5.42893 20.25 7.5 20.25H16.5C18.5711 20.25 20.25 18.5711 20.25 16.5V7.5C20.25 5.42893 18.5711 3.75 16.5 3.75H7.5ZM12 7.5C14.4853 7.5 16.5 9.51472 16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12C7.5 9.51472 9.51472 7.5 12 7.5ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM17.4316 5.03613C18.2778 5.03613 18.9639 5.72218 18.9639 6.56836C18.9636 7.41433 18.2777 8.10059 17.4316 8.10059C16.5858 8.10033 15.8997 7.41418 15.8994 6.56836C15.8994 5.72234 16.5857 5.03638 17.4316 5.03613ZM17.4316 6.08691C17.1656 6.08717 16.9502 6.30223 16.9502 6.56836C16.9504 6.83428 17.1657 7.05053 17.4316 7.05078C17.6978 7.05078 17.9138 6.83443 17.9141 6.56836C17.9141 6.30208 17.6979 6.08691 17.4316 6.08691Z",
    fill: "#FC4C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.e8df155dac5f1ce332b7797b4e5a3ae6.svg";
export { ForwardRef as ReactComponent };